const mandatoryFieldsEnv = process.env.REACT_APP_MANDATORY_FIELDS || '';
const nonMandatoryFieldsEnv = process.env.REACT_APP_NON_MANDATORY_FIELDS || '';

export const MANDATORY_FIELDS = mandatoryFieldsEnv.split(',').map((f) => f.trim().toUpperCase());
export const NON_MANDATORY_FIELDS = nonMandatoryFieldsEnv.split(',').map((f) => f.trim().toUpperCase());
export const MAX_ADDITIONAL_DOCS = Number(process.env.REACT_APP_MAX_ADDITIONAL_DOCS ?? 2);
